<template>
    <div>
        <calculator-base-header-sec></calculator-base-header-sec>
        <div class="col-lg-12 slg-hrm-padding">
            <div class="col-lg-12 col-mg-12 col-sm-12 promo-content">
                <form name="form">
                    <div class="form-group form-group-sm radio" v-if="!scope.fiksne">
                        <label class="radio-btn-label radio-inline">
                            <input type="radio" id="generalJurisdictionCourt" v-model="scope.typeCourt"
                                value="generalJurisdiction" @change="racunaj1()" /> Суд опште надлежности
                        </label>
                    </div>
                    <div class="form-group form-group-sm">
                        <label class="radio-btn-label radio-inline">
                            <input type="radio" id="commercialCourt" v-model="scope.typeCourt" value="commercial"
                                @change="racunaj1()" /> Привредни суд
                        </label>
                    </div>
                    <div class="form-group form-group-sm" v-if="!scope.fiksne">
                        <div class="promo-message-register" v-if="scope.typeCourt == 'commercial'" style="color: red">
                            Када је у поступку пред привредним судом једна од странака физичко лице које није предузетник,
                            плаћа се такса као пред судом опште надлежности!
                        </div>
                    </div>
                    <div class="cacl-tab-header mb-4">
                        <div class="">
                            <div class="btn-group ">
                                <button type="button" class="btn btn-blue-1" @click="izaberiFirst()">
                                    Првостепени поступак</button>
                                <button type="button" class="btn btn-blue-1" @click="izaberiSecond()">
                                    Другостепени поступак</button>
                                <button type="button" class="btn btn-blue-1" @click="izaberiRemedy()">
                                    Поступак по ванредним правним лековима</button>
                                <button type="button" class="btn btn-blue-1" @click="fix()">Фиксне таксе</button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-group-sm" v-if="scope.showFirst">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th align="left" style="width: 40%">ТАКСА - ПРВОСТЕПЕНИ ПОСТУПАК</th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ СПОРА</th>
                                    <th align="left" style="width: 10%"></th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ ТАКСЕ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(itemFirst, index) in scope.arrayFirst" v-bind:key="index">
                                    <td align="left">
                                        {{ itemFirst }}
                                    </td>
                                    <td align="left">
                                        <input id="vrednostSpora3" type="text" class="form-control"
                                            v-model="scope.valueForCalcFirst[index]" @keyup="enterValue(index)"
                                            align="center">
                                    </td>
                                    <td align="left">
                                        <input class="btn btn-blue-1 btn-sm" type="button" value="Израчунај"
                                            @click="racunaj(index)">
                                    </td>
                                    <td align="left">
                                        <label v-show="scope.takse[index] > 0">
                                            {{ numeral(scope.takse[index]).format('0.0,').replace(/ /g, '.') }} дин.
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group form-group-sm" v-if="scope.showSecond">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th align="left" style="width: 40%">ТАКСА - ДРУГОСТЕПЕНИ ПОСТУПАК</th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ СПОРА</th>
                                    <th align="left" style="width: 10%"></th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ ТАКСЕ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(itemSecond, index) in scope.arraySecond" v-bind:key="index">
                                    <td align="left">
                                        {{ itemSecond }}
                                    </td>
                                    <td align="left">
                                        <input id="vrednostSpora1" type="text" class="form-control"
                                            v-model="scope.valueForCalcFirst[index]" @keyup="enterValue(index)"
                                            align="center">
                                    </td>
                                    <td align="left">
                                        <input id="10" class="btn btn-blue-1 btn-sm" type="button" value="Израчунај"
                                            @click="racunaj(index)">
                                    </td>
                                    <td align="left">
                                        <label v-show="scope.takse[index] > 0">
                                            {{ numeral(scope.takse[index]).format('0.0,').replace(/ /g, '.') }} дин.
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="form-group form-group-sm" v-if="scope.showRemedy">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th align="left" style="width: 40%">ТАКСА - ПРАВНИ ЛЕК</th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ СПОРА</th>
                                    <th align="left" style="width: 10%"></th>
                                    <th align="left" style="width: 25%">ВРЕДНОСТ ТАКСЕ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(itemRemedy, index) in scope.arrayRemedy" v-bind:key="index">
                                    <td align="left">
                                        {{ itemRemedy }}
                                    </td>
                                    <td align="left">
                                        <input id="vrednostSpora2" type="text" class="form-control"
                                            v-model="scope.valueForCalcFirst[index]" @keyup="enterValue(index)"
                                            align="center">
                                    </td>
                                    <td align="left">
                                        <input id="11" class="btn btn-blue-1 btn-sm" type="button" value="Израчунај"
                                            @click="racunaj(index)">
                                    </td>
                                    <td align="left">
                                        <label v-show="scope.takse[index] > 0">
                                            {{ numeral(scope.takse[index]).format('0.0,').replace(/ /g, '.') }} дин.
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="form-group form-group-sm" v-if="scope.fiksne">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th style="width: 80%">ФИКСНЕ ТАКСЕ</th>
                                    <th style="width: 20%">ВРЕДНОСТ ТАКСЕ</th>
                                </tr>
                            </thead>
                            <tr>
                                <td>РАЗНО: ТУЖБЕ, ПРЕДЛОЗИ, ЗАХТЕВИ И ДРУГО</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Такса на тужбу за развод брака </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Приватна кривична тужба </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за предлог за уређење међе</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Такса за предлог за физичку деобу</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за издавање уверења </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за опомену за плаћање таксе</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса на захтев за изузеће судије </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса на захтев за одлагање извршења кривичне санкције </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за састављање судског тестамента </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за чување судског тестамента </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Такса на молбу и решење за дозволу за ступање у брак малолетницима .</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за разгледање завршених предмета </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за давање извештаја и података из завршених предмета </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>ОВЕРЕ:</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Такса за оверу пуномоћја – овлашћења </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за депоновање потписа</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу изјаве </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу сагласности </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу потписа </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу заложне изјаве </td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу фотокопије преписа (једна оверена фотокопија) свака наредна фотокопија се
                                    доплаћује са 160,00 динара (по листу).</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу потписа, преписа или рукописа „Apostille“ за употребу у иностранству</td>
                                <td> </td>
                            </tr>
                            <tr>
                                <td>Такса за оверу потписа судског преводиоца на преводе ради употребе у иностранству </td>
                                <td> </td>
                            </tr>
                        </table>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CalculatorBaseHeaderSec from '@/base_pages/calc/CalculatorBaseHeaderSec.vue';
import numeral from 'numeral';


export default {
    name: "CourtFeesCalculator",
    data() {
        return {
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,
             

            numeral: numeral,

            scope: {
                // typeCourt: 'generalJurisdiction',
                // showFirst: true,
                // showSecond: false,
                // showRemedy: false,
                // fiksne: false,

                show: false,
                fiksne: false,
                showFirst: false,
                showSecond: false,
                showRemedy: false,
                valueForCalcFirst: [],
                court: false,
                calculate: false,
                takse: [],
                value: [],
                typeCourt: 'generalJurisdiction',
                arrayFirst: ["Такса за тужбу",
                    "Такса за противтужбу",
                    "Такса за предлог да се одреди извршење на основу извршне или веродостојне исправе",
                    "Такса за предлог за обезбеђење",
                    "Такса за приговор и жалбу поднете у поступку побијања решења о извршењу на основу извршне или веродостојне исправе или решења о обезбеђењу",
                    "Такса за предлог за обезбеђење доказа",
                    "Такса за одговор на тужбу",
                    "Такса за жалбу против пресуде или решења и за жалбу против решења у споровима због сметања поседа",
                    "Такса за поравнање",
                    "Такса за пресуду",
                    "Такса за пресуду на основу признања, одрицања или попуштања",
                    "Такса за решење о одбацивању тужбе",
                    "Такса за решење о издавању платног налога",
                    "Такса за решење донето по предлогу за обезбеђење",
                    "Такса за решење донето по предлогу за извршење на основу веродостојне исправе",
                    "Такса за решење о извршењу донето на основу иностраних извршних исправа",
                    "Такса за решење о трошковима поступка"

                ],
                arraySecond: ["Такса за тужбу",
                    "Такса за противтужбу",
                    "Такса за жалбу против пресуде или решења",
                    "Такса за жалбу против решења у споровима због сметања поседа",
                    "Такса за жалбу против решења којим се одбија или одбацује предлог за повраћај у пређашње стање",
                    "Такса за одговор на жалбу",
                    "Такса за другостепену одлуку (изузев одбацујуће или укидајуће одлуке у ком случају се не плаћа такса)",
                    "Такса за другостепену одлуку",
                    "Такса за решење којим се усваја, одбија или одбацује предлог за повраћај у пређашње стање",
                    "Такса за решење за враћање у пређашње стањe"
                ],
                arrayRemedy: ["Такса за ревизију",
                    "Такса за предлог за понављање поступка",
                    "Такса за одговор на ревизију",
                    "Такса за одлуку суда по вандредним лековима (ако је том одлуком одбачено ванредно правно средство  или ако је одлука суда нижег степена укинута, у ком случају се такса не плаћа)"
                ],

                allowSymbol: ["0123456789.,"],
            },
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        CalculatorBaseHeaderSec,
    },
    methods: {
        enterValue(ind) {
            this.$set(this.scope.value, ind, this.convertDecimalNUmber(this.scope.valueForCalcFirst[ind]));
            this.$set(this.scope.takse, ind, '');
        },

        convertDecimalNUmber(num) {
            var strNum = num.replace(",", ".");
            return parseFloat(strNum);
        },

        fix() {
            this.scope.showFirst = false;
            this.scope.showSecond = false;
            this.scope.showRemedy = false;
            this.scope.fiksne = true;
        },

        racunaj1() {
            if (this.scope.showFirst) {
                this.scope.id = 0;
            }
            if (this.scope.showSecond) {
                this.scope.id = this.scope.arrayFirst.length;
            }
            if (this.scope.showRemedy) {
                this.scope.id = this.scope.arrayFirst.length + this.scope.arraySecond.length;
            }

            for (var num = 0; num < this.scope.value.length; num++) {

                var value = null;

                if (this.scope.value[num] > 0) {
                    if ((this.scope.id + num) === 2 || (this.scope.id + num) === 3 || (this.scope.id + num) === 4 || (this.scope.id + num) === 5 || (this.scope.id + num) === 6 || (this.scope.id + num) === 8 || (this.scope.id + num) === 10 || (this.scope.id + num) === 12 || (this.scope.id + num) === 13 || (this.scope.id + num) === 14 || (this.scope.id + num) === 22 || (this.scope.id + num) === 29) {
                        if (this.scope.typeCourt === 'generalJurisdiction') {
                            value = 0.5 * this.f_la_general(this.scope.value[num]);
                        } else {
                            value = 0.5 * this.f_la_commercial(this.scope.value[num]);
                        }
                    }

                    if ((this.scope.id + num) === 0 || (this.scope.id + num) === 1 || (this.scope.id + num) === 7 || (this.scope.id + num) === 9 || (this.scope.id + num) === 15 || (this.scope.id + num) === 16 || (this.scope.id + num) === 17 || (this.scope.id + num) === 18 || (this.scope.id + num) === 19 || (this.scope.id + num) === 20 || (this.scope.id + num) === 23 || (this.scope.id + num) === 24) {
                        if (this.scope.typeCourt === 'generalJurisdiction') {
                            value = this.f_la_general(this.scope.value[num]);
                        } else {
                            value = this.f_la_commercial(this.scope.value[num]);
                        }
                    }

                    if ((this.scope.id + num) === 28 || (this.scope.id + num) === 27) {
                        if (this.scope.typeCourt === 'generalJurisdiction') {
                            value = 2 * this.f_la_general(this.scope.value[num]);
                        } else {
                            if (2 * this.f_la_commercial(this.scope.value[num]) <= 420000)
                                value = 2 * this.f_la_commercial(this.scope.value[num]);
                            else
                                value = 420000;
                        }
                    }
                    if ((this.scope.id + num) === 30) {
                        if (this.scope.typeCourt === 'generalJurisdiction') {
                            value = 3 * this.f_la_general(this.scope.value[num]);
                        } else {
                            if (3 * this.f_la_commercial(this.scope.value[num]) <= 420000)
                                value = 3 * this.f_la_commercial(this.scope.value[num]);
                            else
                                value = 420000;
                        }
                    }

                    if ((this.scope.id + num) === 11) {
                        this.f_la(15000, 27000, 0.5, num);
                    }
                    if ((this.scope.id + num) === 21 || (this.scope.id + num) === 25 || (this.scope.id + num) === 26) {
                        this.f_la(2800, 27000, 0.5, num);
                    }
                }

                if (value !== null) {
                    this.$set(this.scope.takse, num, value);
                }

            }
        },

        racunaj(num) {

            var value = null;

            this.scope.calculate = true;
            if (this.scope.showFirst) {
                this.scope.id = num;
            }
            if (this.scope.showSecond) {
                this.scope.id = num + this.scope.arrayFirst.length;
            }
            if (this.scope.showRemedy) {
                this.scope.id = num + this.scope.arrayFirst.length + this.scope.arraySecond.length;
            }
            if (this.scope.value[num] > 0) {
                if (this.scope.id === 2 || this.scope.id === 3 || this.scope.id === 4 || this.scope.id === 5 || this.scope.id === 6 || this.scope.id === 8 || this.scope.id === 10 || this.scope.id === 12 || this.scope.id === 13 || this.scope.id === 14 || this.scope.id === 22 || this.scope.id === 29) {
                    if (this.scope.typeCourt === 'generalJurisdiction') {
                        value = 0.5 * this.f_la_general(this.scope.value[num]);
                    } else {
                        value = 0.5 * this.f_la_commercial(this.scope.value[num]);
                    }
                }

                if (this.scope.id === 0 || this.scope.id === 1 || this.scope.id === 7 || this.scope.id === 9 || this.scope.id === 15 || this.scope.id === 16 || this.scope.id === 17 || this.scope.id === 18 || this.scope.id === 19 || this.scope.id === 20 || this.scope.id === 23 || this.scope.id === 24) {
                    if (this.scope.typeCourt === 'generalJurisdiction') {
                        value = this.f_la_general(this.scope.value[num]);
                    } else {
                        value = this.f_la_commercial(this.scope.value[num]);
                    }
                }

                if (this.scope.id === 28 || this.scope.id === 27) {
                    if (this.scope.typeCourt === 'generalJurisdiction') {
                        value = 2 * this.f_la_general(this.scope.value[num]);
                    } else {
                        if (2 * this.f_la_commercial(this.scope.value[num]) <= 420000)
                            value = 2 * this.f_la_commercial(this.scope.value[num]);
                        else
                            value = 420000;
                    }
                }
                if (this.scope.id === 30) {
                    if (this.scope.typeCourt === 'generalJurisdiction') {
                        value = 3 * this.f_la_general(this.scope.value[num]);
                    } else {
                        if (3 * this.f_la_commercial(this.scope.value[num]) <= 420000)
                            value = 3 * this.f_la_commercial(this.scope.value[num]);
                        else
                            value = 420000;
                    }
                }

                if (this.scope.id === 11) {
                    this.f_la(15000, 27000, 0.5, num);
                }
                if (this.scope.id === 21 || this.scope.id === 25 || this.scope.id === 26) {
                    this.f_la(2800, 27000, 0.5, num);
                }
            }

            if (value !== null) {
                this.$set(this.scope.takse, num, value);
            }
        },

        izaberiRemedy() {
            this.scope.showFirst = false;
            this.scope.showSecond = false;
            this.scope.showRemedy = true;
            this.scope.fiksne = false;
            for (var i = 0; i < this.scope.arrayRemedy.length; i++) {
                this.scope.value[i] = "";
                this.scope.takse[i] = "";
                this.scope.valueForCalcFirst[i] = "";
            }
        },

        izaberiFirst() {
            this.scope.showFirst = true;
            this.scope.showSecond = false;
            this.scope.showRemedy = false;
            this.scope.fiksne = false;
            for (var i = 0; i < this.scope.arrayFirst.length; i++) {
                this.scope.value[i] = "";
                this.scope.takse[i] = "";
                this.scope.valueForCalcFirst[i] = "";
            }
        },

        izaberiSecond() {
            this.scope.showFirst = false;
            this.scope.showSecond = true;
            this.scope.showRemedy = false;
            this.scope.fiksne = false;
            for (var i = 0; i < this.scope.arraySecond.length; i++) {
                this.scope.value[i] = "";
                this.scope.takse[i] = "";
                this.scope.valueForCalcFirst[i] = "";
            }
        },

        f_la(valueGeneral, valueCommercial, multiple, num) {

            var value = null;

            if (this.scope.typeCourt === 'generalJurisdiction') {
                if (multiple * this.f_la_general(this.scope.value[num]) <= valueGeneral) {
                    value = multiple * this.f_la_general(this.scope.value[num]);
                } else {
                    value = valueGeneral;
                }
            } else {
                if (multiple * this.f_la_commercial(this.scope.value[num]) <= valueCommercial) {
                    value = multiple * this.f_la_commercial(this.scope.value[num]);
                } else {
                    value = valueCommercial;
                }
            }

            if (value !== null) {
                this.$set(this.scope.takse, num, value);
            }

        },

        f_la_general(x) {
            if (x <= 10000) return 2800;
            if (x > 10000 && x <= 100000) return 2800 + 0.04 * x;
            if (x > 100000 && x <= 500000) return 11000 + 0.02 * x;
            if (x > 500000 && x <= 1000000) return 32000 + 0.01 * x;
            if (x > 1000000) {
                if ((53000 + 0.005 * x) <= 105000) return 53000 + 0.005 * x;
                else return 105000;
            } return 0;
        },

        f_la_commercial(x) {
            if (x <= 10000) return 5000;
            if (x > 10000 && x <= 100000) return 5000 + 0.06 * x;
            if (x > 100000 && x <= 1000000) return 17000 + 0.02 * x;
            if (x > 1000000 && x <= 10000000) return 60000 + 0.01 * x;
            if (x > 10000000) {
                if ((275000 + 0.005 * x) <= 420000) return 275000 + 0.005 * x;
                else return 420000;
            } return 0;
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    }
}
</script>

<style scoped></style>
